// extracted by mini-css-extract-plugin
export default {"wrapper":"FavoriteMovie_wrapper__5yWcg","icon":"FavoriteMovie_icon__Bto16","list":"FavoriteMovie_list__brSRn"};